import { render, staticRenderFns } from "./OpenButton.vue?vue&type=template&id=17994cb2&scoped=true&"
import script from "./OpenButton.vue?vue&type=script&lang=js&"
export * from "./OpenButton.vue?vue&type=script&lang=js&"
import style0 from "./OpenButton.vue?vue&type=style&index=0&id=17994cb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17994cb2",
  null
  
)

export default component.exports